import { TextLink } from '@lux/text-link';
import { ComplementaryColor, Spacer } from '@lux/tokens';
import styled from 'styled-components';

export const CarouselContainer = styled.div`
    padding-bottom: 0;
`;

export const BeforeTitleBadge = styled.div`
    background-color: ${ComplementaryColor.neonFresh};
    padding: ${Spacer.XXS} ${Spacer.XS};
    margin: ${Spacer.SM} ${Spacer.S} 0 ${Spacer.S};
    display: inline-block;
`;

export const AfterTitleLink = styled(TextLink)`
    margin: 0 ${Spacer.S} ${Spacer.SM} ${Spacer.S};
    display: inline-block;
`;
